/**
 * 2007-2018 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2018 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'intersection-observer';

// import fontawesome from "@fortawesome/fontawesome";
// import farCalendar from "@fortawesome/fontawesome-pro-regular/faCalendarAlt";
// import farEnvelope from "@fortawesome/fontawesome-pro-regular/faEnvelope";
// import fasArrowUp from "@fortawesome/fontawesome-pro-solid/faArrowUp";
//
// fontawesome.library.add(farCalendar, farEnvelope, fasArrowUp);
// FONT AWESOME ICONS

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './display';

import DropDown from './components/drop-down';
import Form from './components/form';
import TopMenu from './components/top-menu';

import FetchThenExecute from './utils/fetchThenExecute';
import SearchBarAutocomplete from './components/search-bar-autocomplete';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import 'jquery-zoom';

import './lib/bootstrap-filestyle.min';
import './lib/total-storage';

import './components/block-cart';
import {debounce} from './utils/utils';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
    let dropDownEl = $('.js-dropdown');
    const form = new Form();
    let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
    let dropDown = new DropDown(dropDownEl);
    let topMenu = new TopMenu(topMenuEl);
    dropDown.init();
    form.init();
    topMenu.init();
    fetchSliders();
    removeAlertOnFormFiledOnFocus();
    initFixedMenu();

    $('[data-toggle="menu"]').on('click', (e) => {
        e.preventDefault();
        $('body').toggleClass('menu-open');
    });


});


// EXAMPLE OF USAGE
function initSearchBar() {
    const $searchBoxHeader = $('.searchBox--header');
    const $formHeader = $searchBoxHeader.find('.searchBox__form');
    const url = $formHeader.attr('data-search-controller-url');
    const $input = $formHeader.find('.searchBox__input');

    const formatResult = (product) => {
        let output = [];

        if (product && product.length) {
            output = product.map(el => {
                const $div = $('<div>');

                const html = `
          <a href="${el.url}">
            <span class="autocomplete__name">
              ${el.name}
            </span>
          </a>
        `;

                $div.addClass('autocomplete__element')
                    .append(html);

                return $div;
            })
        }

        return output;
    }

    const autocomplete = new SearchBarAutocomplete({
        url,
        appendTo: $formHeader,
        formatFunction: formatResult,
        inputEl: $input
    })

    const $searchBoxNotFound = $('.searchBox--notfound');

    if ($searchBoxNotFound.length > 0) {
        const $formNotFound = $searchBoxNotFound.find('.searchBox__form');
        const urlNotFound = $formNotFound.attr('data-search-controller-url');
        const $inputNotFound = $formNotFound.find('.searchBox__input');

        const notFoundSearch = new SearchBarAutocomplete({
            urlNotFound,
            appendTo: $formNotFound,
            formatFunction: formatResult,
            inputEl: $inputNotFound
        })
    }


}


function fetchSliders() {
    const initSliders = new FetchThenExecute({
        selector: '.theme-slider',
        files: () => ([
            import('../css/components/slick-theme.scss'),
            import('../css/components/slick.scss'),
            import('./lib/slick.min.js')
        ]),
        fnc: initSlider
    })

    prestashop.on('updatedProduct', () => {
        initSliders.update();
    });
}

function initSlider(el) {
    const $elem = $(el);

    if ($elem.hasClass('products')) {
        initProductsSlider($elem);
    } else if ($elem.hasClass('homeSlider__list')) {
        initHomeSlider($elem)
    } else if ($elem.hasClass('productThumbs')) {
        initProductThumbsSlider($elem)
    } else if ($elem.hasClass('js-modal-product-images')) {
        initModalImgSlider($elem)
    } else if ($elem.hasClass('uspbox-slider')) {
        initUspBoxSlider($elem)
    }
}


function initProductsSlider($el) {
    $el.slick({
        dots: false,
        infinite: true,
        speed: 600,
        autoplay: false,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function initModalImgSlider($el) {
    $el.slick({
        infinite: false,
        arrows: false,
        speed: 300,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function initUspBoxSlider($el) {
    $el.slick({
        infinite: true,
        arrows: false,
        autoplay: true,
        slidesToShow: 8,
        centerMode: false,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });
}

function initHomeSlider($el) {
    const infinite = $el.attr('data-wrap') == 'true';
    const autoplaySpeed = $el.attr('data-interval');
    const pauseOnHover = $el.attr('data-pause') == 'hover';

    $el.slick({
        infinite,
        autoplay: true,
        autoplaySpeed,
        pauseOnHover,
        arrows: false,
        speed: 600,
        autoplay: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    });
}

function initProductThumbsSlider($el) {
    $el.slick({
        infinite: false,
        arrows: true,
        speed: 600,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function removeAlertOnFormFiledOnFocus() {
    const $formElement = $('.form-control.is-invalid');

    $formElement.on('focus', ({target}) => {
        const $target = $(target);
        const $parentContainer = $target.parent();

        $target.removeClass('is-invalid');
        $parentContainer.find('.alert').closest('.help-block').remove();
    })
}


function initFixedMenu() {
    if ($(window).innerWidth() < 992 || prestashop.page.page_name === 'checkout') {
        return;
    }

    const $headerTopContainer = $('.header-top');
    const $header = $('#header');
    const $body = $('body');

    $headerTopContainer.after($('<div>').addClass('fixed-offset'));

    const $fixedOffset = $('.fixed-offset');

    const fixingHeader = debounce(() => {
        if ($(window).scrollTop() > $header.height()) {
            if (!$body.hasClass('header-fixed')) {
                $fixedOffset.css('height', $headerTopContainer.outerHeight());
                $body.addClass('header-fixed');
            }
        } else {
            if ($body.hasClass('header-fixed')) {
                $fixedOffset.css('height', '0');
                $body.removeClass('header-fixed');
            }
        }
    }, 10);

    fixingHeader();
    $(window).on('scroll', fixingHeader);
}
